module.exports = __webpack_public_path__ + "static/media/background-image-gradient.3d4ac067.webp";